module.exports = __webpack_public_path__ + "img/logo.31cd5c98.jpg";